import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-verification',
  templateUrl: './step-verification.component.html'
})
export class StepVerificationComponent {

  constructor(public mdcService: MdcService) { }

}
